// src/components/operationCenter/widgets/GoldenRatioMultiplierWidget.tsx
// Widget wrapper for Golden Ratio Multiplier long-term valuation indicator

import React, { useRef, useState, useEffect } from "react";
import type { WidgetProps } from "@/types/dashboard";
import { GoldenRatioMultiplierChart } from "@/components/indices/GoldenRatioMultiplierChart";

const GoldenRatioMultiplierWidget: React.FC<WidgetProps> = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerHeight, setContainerHeight] = useState(300);

  // Measure container height for ECharts
  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current) {
        const height = containerRef.current.clientHeight;
        if (height > 0) {
          setContainerHeight(height);
        }
      }
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="h-full w-full overflow-hidden">
      <GoldenRatioMultiplierChart height={containerHeight} />
    </div>
  );
};

export default GoldenRatioMultiplierWidget;

